import classNames from 'classnames';
import { Link, useLocation } from 'wouter';

import styles from '../../../styles/menus/menu.module.scss';

interface MenuProps {
    className?: string;
    itemsClassName?: string;
    itemClassName?: string;
    itemActiveClassName?: string;
    items: MenuItem[];
    onItemClick?: () => void;
}

const Menu = ({
    className = null,
    itemsClassName = null,
    itemClassName = null,
    itemActiveClassName = null,
    items = null,
    onItemClick = null,
}: MenuProps) => {
    const [pathname] = useLocation();

    return (
        <nav
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <ul
                className={classNames([
                    styles.items,
                    {
                        [itemsClassName]: itemsClassName !== null,
                    },
                ])}
            >
                {(items || []).map(({ label, url, external = false, target = null }, index) => {
                    const active = pathname === url;
                    return (
                        <li
                            className={classNames([
                                styles.item,
                                {
                                    [itemClassName]: itemClassName !== null,
                                    [itemActiveClassName]: itemActiveClassName !== null && active,
                                    [styles.active]: active,
                                    [styles.external]: external === true,
                                },
                            ])}
                            key={`item-${index + 1}`}
                        >
                            {external ? (
                                <a
                                    href={url}
                                    target={target || '_blank'}
                                    rel="noreferrer"
                                    className={styles.link}
                                    onClick={onItemClick}
                                >
                                    {label}
                                </a>
                            ) : (
                                <Link href={url} onClick={onItemClick} className={styles.link}>
                                    {label}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default Menu;
